'use client';

import { useEffect, useRef } from 'react';
import Image from 'next/image';
import { useGetCurrencyIcon, useGetStaticResource } from '@/services/static-resource';
import { useBalanceFormatter } from '@/hooks/use-balance-formatter';
import { toNum } from '@/libs/decimal';
import { cn } from '@/utils/classnames';
import styles from './style.module.css';

interface RechargeAnimationProps {
  currency: string;
  amount: string;
  onAnimationCompleteAction: () => void;
}

export function RechargeAnimation({
  currency,
  amount,
  onAnimationCompleteAction,
}: RechargeAnimationProps) {
  const animationRef = useRef<HTMLDivElement>(null);
  const { data: staticResource } = useGetStaticResource();
  const getCurrencyIcon = useGetCurrencyIcon();
  const { formatBalanceDetail } = useBalanceFormatter();

  // 获取货币图标
  const currencyIcon = getCurrencyIcon(currency, staticResource);

  // 处理动画完成事件
  useEffect(() => {
    const handleAnimationEnd = () => {
      // 动画完成，调用回调并移除组件
      onAnimationCompleteAction();
    };

    const element = animationRef.current;
    if (element) {
      element.addEventListener('animationend', handleAnimationEnd);
      return () => {
        element.removeEventListener('animationend', handleAnimationEnd);
      };
    }
  }, [onAnimationCompleteAction]);

  return (
    <div
      ref={animationRef}
      className={cn(styles.container)}
    >
      <div className={styles.content}>
        {currencyIcon && (
          <Image
            src={currencyIcon}
            alt={currency}
            width={16}
            height={16}
          />
        )}
        <div className={cn('flex-1 text-white text-xs text-right font-semibold', styles.amount)}>
          +{formatBalanceDetail(toNum(amount), currency)}
        </div>
      </div>
    </div>
  );
}

